module.exports = __webpack_public_path__ + "img/address1.bb4c6b72.png";